import { useAppTranslation } from "@/utils";
import { BatchPaymentDetailsReasonCodeEnum, TransferMethodEnum } from "@payping/api";

export const useTransferLabel = () => {
  const { t } = useAppTranslation();

  const getLabelTransfer = (transferType?: TransferMethodEnum) => {
    switch (transferType) {
      case TransferMethodEnum.AccountToAccount:
        return t("digitalAccount.samanCreate.transferType.accountToAccount");
      case TransferMethodEnum.Paya:
        return t("digitalAccount.samanCreate.transferType.paya");
      case TransferMethodEnum.Satna:
        return t("digitalAccount.samanCreate.transferType.satna");
      default:
        return "";
    }
  };

  const getLabelReasonTransfer = (reasonCode?: BatchPaymentDetailsReasonCodeEnum) => {
    switch (reasonCode) {
      case BatchPaymentDetailsReasonCodeEnum.CCPA:
        return t("digitalAccount.samanCreate.depositOfCollateral");
      case BatchPaymentDetailsReasonCodeEnum.CDAP:
        return t("digitalAccount.samanCreate.customsDuties");
      case BatchPaymentDetailsReasonCodeEnum.CPAC:
        return t("digitalAccount.samanCreate.cashAndCharityDonations");
      case BatchPaymentDetailsReasonCodeEnum.DRPA:
        return t("digitalAccount.samanCreate.debtPayment");
      case BatchPaymentDetailsReasonCodeEnum.FRTX:
        return t("digitalAccount.samanCreate.otherMatters");
      case BatchPaymentDetailsReasonCodeEnum.FXAP:
        return t("digitalAccount.samanCreate.currencyAffairs");
      case BatchPaymentDetailsReasonCodeEnum.GASP:
        return t("digitalAccount.samanCreate.buyingGoodsAndServices");
      case BatchPaymentDetailsReasonCodeEnum.GEAC:
        return t("digitalAccount.samanCreate.otherGovernmentServices");
      case BatchPaymentDetailsReasonCodeEnum.GPAC:
        return t("digitalAccount.samanCreate.generalExpensesAndDailyAffairs");
      case BatchPaymentDetailsReasonCodeEnum.HIPA:
        return t("digitalAccount.samanCreate.medicalAffairs");
      case BatchPaymentDetailsReasonCodeEnum.IMPT:
        return t("digitalAccount.samanCreate.realEstateTransactions");
      case BatchPaymentDetailsReasonCodeEnum.IOSP:
        return t("digitalAccount.samanCreate.serviceInsuranceAffairs");
      case BatchPaymentDetailsReasonCodeEnum.ISAP:
        return t("digitalAccount.samanCreate.investmentAndStockMarketAffairs");
      case BatchPaymentDetailsReasonCodeEnum.LMAP:
        return t("digitalAccount.samanCreate.liquidityManagement");
      case BatchPaymentDetailsReasonCodeEnum.LRPA:
        return t("digitalAccount.samanCreate.facilityRepayment");
      case BatchPaymentDetailsReasonCodeEnum.MPTP:
        return t("digitalAccount.samanCreate.movablePropertyTransactions");
      case BatchPaymentDetailsReasonCodeEnum.POSA:
        return t("digitalAccount.samanCreate.salaryDeposit");
      case BatchPaymentDetailsReasonCodeEnum.RTAP:
        return t("digitalAccount.samanCreate.retirementAffairs");
      case BatchPaymentDetailsReasonCodeEnum.TCAP:
        return t("digitalAccount.samanCreate.taxSettlement");
      default:
        return "";
    }
  };

  return { getLabelTransfer, getLabelReasonTransfer };
};

export default useTransferLabel;
